<script setup lang="ts">
import type { BlokLinkListItem } from "@/.storyblok/types/120421/storyblok-components";

const props = defineProps<{
  blok: BlokLinkListItem;
}>();

const icon = computed(() => {
  const targetUrl = props.blok?.link?.cached_url;

  if (/.(pdf|PDF)/.test(targetUrl)) {
    return "mdi:file-pdf-box";
  }
  if (/.(jpg|JPG|jpeg|JPEG)/.test(targetUrl)) {
    return "mdi:file-jpg-box";
  }
  if (/.(png|PNG)/.test(targetUrl)) {
    return "mdi:file-png-box";
  }

  return "mdi:open-in-new";
});
</script>

<template>
  <BaseLink v-editable="blok" v-bind="blok.link" target="_blank" rel="noopener" class="flex">
    <Icon
      :name="icon"
      class="text-brandDark text-4xl flex-shrink-0 mr-2"
    ></Icon>
    <span>
      <strong>{{ blok.headline }}</strong>
      <p class="whitespace-pre-line">{{ blok.description }}</p>
    </span>
  </BaseLink>
</template>
